import { useHistory } from 'react-router-dom';
import { FILTER_TYPE, SORT_ORDER } from '../constants/url';

type setFiltersType = {
  status: string;
  created_by: string;
  requestStatus: string;
  monetisationStatus: string;
  dateRange: string;
};

type useFiltersType = [
  {
    status: string[];
    created_by: string[];
    requestStatus: string[];
    monetisationStatus: string[];
    dateRange: string[];
  },
  ({
    status,
    created_by,
    requestStatus,
    monetisationStatus,
    dateRange,
  }: setFiltersType) => void,
];

export function useFilters(): useFiltersType {
  const {
    location: { search },
    push,
  } = useHistory();
  const searchParams = new URLSearchParams(search);
  const statusFilters = searchParams.get(FILTER_TYPE.STATUS);
  const createdByFilters = searchParams.get(FILTER_TYPE.CREATED_BY);
  const requestStatusFilters = searchParams.get(FILTER_TYPE.REQUEST_STATUS);
  const monetisationStatusFilters = searchParams.get(
    FILTER_TYPE.MONETISATION_STATUS,
  );
  const dateRangeFilters = searchParams.get(FILTER_TYPE.DATE_RANGE);

  function setFilters(filters: setFiltersType) {
    searchParams.set(FILTER_TYPE.STATUS, filters.status);
    searchParams.set(FILTER_TYPE.CREATED_BY, filters.created_by);
    searchParams.set(
      FILTER_TYPE.MONETISATION_STATUS,
      filters.monetisationStatus,
    );
    searchParams.set(FILTER_TYPE.REQUEST_STATUS, filters.requestStatus);
    searchParams.set(FILTER_TYPE.DATE_RANGE, filters.dateRange);
    push({ search: searchParams.toString() });
  }

  return [
    {
      status: statusFilters ? statusFilters.split(',') : [],
      created_by: createdByFilters ? createdByFilters.split(',') : [],
      requestStatus: requestStatusFilters
        ? requestStatusFilters.split(',')
        : [],
      monetisationStatus: monetisationStatusFilters
        ? monetisationStatusFilters.split(',')
        : [],
      dateRange: dateRangeFilters ? dateRangeFilters.split(',') : [],
    },
    setFilters,
  ];
}

type useSortType = [SORT_ORDER, (selectedSort: SORT_ORDER) => void];

export function useSort(): useSortType {
  const {
    location: { search },
    push,
  } = useHistory();
  const searchParams = new URLSearchParams(search);
  const sort: SORT_ORDER | null = searchParams.get(
    FILTER_TYPE.SORT,
  ) as SORT_ORDER;

  function setSort(selectedSort: SORT_ORDER) {
    searchParams.set(FILTER_TYPE.SORT, selectedSort);
    push({ search: searchParams.toString() });
  }

  if (sort) {
    return [sort, setSort];
  }
  return [SORT_ORDER.DESC, setSort];
}
